import type {
  CancelablePromise,
  TCreateSalesCommissionRequest,
  TCreateSalesCommissionResponse,
  TGetSalesCommissionRequest,
  TGetSalesCommissionResponse,
  TListSalesCommissionsRequest,
  TListSalesCommissionsResponse,
} from '/src/api';
import { OpenAPI, request as __request } from '/src/api';

export class SalesCommissionService {
  /**
   * List Sales Commissions
   * @returns SalesCommission[] SalesCommission[]
   * @throws ApiError
   */
  public static listSalesCommissions(
    req?: TListSalesCommissionsRequest
  ): CancelablePromise<TListSalesCommissionsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/salesCommissionRates',
      query: req?.page ? { page: req.page } : undefined,
    });
  }

  /**
   * Get Sales Commission
   * @param email string
   * @param password string
   * @returns SalesCommission SalesCommission
   * @throws ApiError
   */
  public static getSalesCommission({ id }: TGetSalesCommissionRequest): CancelablePromise<TGetSalesCommissionResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/salesCommissionRates/{id}',
      path: { id },
    });
  }

  /**
   * Create Sales Commission
   * @param salesCommission SalesCommission
   * @returns SalesCommission SalesCommission
   * @throws ApiError
   */
  public static createSalesCommission(
    req: TCreateSalesCommissionRequest
  ): CancelablePromise<TCreateSalesCommissionResponse> {
    const { client_id, ...requestBody } = req;
    return __request(OpenAPI, {
      method: 'POST',
      url: `/clients/${client_id}/salesCommissionRates`,
      body: requestBody,
    });
  }
}
